// ============================================
// NAVIGATION JAVASCRIPT
// Active states, smooth interactions
// ============================================

document.addEventListener('DOMContentLoaded', function() {
  
  // Get current page path
  const currentPath = window.location.pathname;
  
  // Highlight active nav link
  const navLinks = document.querySelectorAll('.navbar-nav .nav-link');
  navLinks.forEach(link => {
    const linkPath = new URL(link.href).pathname;
    
    // Exact match
    if (linkPath === currentPath) {
      link.classList.add('active');
    }
    
    // Parent section match (for dropdown items)
    if (currentPath.startsWith(linkPath) && linkPath !== '/') {
      link.classList.add('active');
    }
  });
  
  // Close mobile menu on link click
  const navbarCollapse = document.getElementById('mainNav');
  if (navbarCollapse) {
    const navLinks = navbarCollapse.querySelectorAll('.nav-link:not(.dropdown-toggle)');
    
    navLinks.forEach(link => {
      link.addEventListener('click', function() {
        // Check if mobile menu is open
        if (navbarCollapse.classList.contains('show')) {
          const bsCollapse = new bootstrap.Collapse(navbarCollapse, {
            toggle: true
          });
        }
      });
    });
  }
  
  // Smooth dropdown animations
  const dropdownMenus = document.querySelectorAll('.dropdown-menu');
  dropdownMenus.forEach(menu => {
    menu.addEventListener('show.bs.dropdown', function() {
      this.style.display = 'block';
      setTimeout(() => {
        this.classList.add('show');
      }, 10);
    });
  });
  
  // Scroll-driven header effects intentionally removed for a static experience.
  
});

// Scroll-driven navbar shadow intentionally removed.

